/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current status of the scheduled bot
 */
export type GetScheduledBotResponseDataStatus =
  (typeof GetScheduledBotResponseDataStatus)[keyof typeof GetScheduledBotResponseDataStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetScheduledBotResponseDataStatus = {
  scheduled: "scheduled",
  cancelled: "cancelled",
  completed: "completed",
  failed: "failed"
} as const
